import type { ReactNode } from "react";
import { Navigate } from "react-router";
import { ROUTES } from "@/router";
import type { IPermission } from "../PermissionGuard/constant";
import { usePermissions } from "../PermissionGuard/hooks";

type IProps = {
  permissions: IPermission[];
  children: ReactNode;
  fallback?: ReactNode;
  redirect?: boolean | string;
};

const PermissionGuard = ({
  permissions,
  children,
  fallback = null,
  redirect = false,
}: IProps) => {
  const { hasPermissions } = usePermissions();
  const hasAccess = hasPermissions(permissions);

  if (!hasAccess && redirect) {
    const redirectPath = typeof redirect === "string" ? redirect : ROUTES.ROOT;
    return <Navigate to={redirectPath} replace />;
  }

  return hasAccess ? children : fallback;
};

export default PermissionGuard;
